/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2022 ICEMEDX, Inc.
***********************************************/
import { IceMultimediaAttributes } from './IceMultimediaAttributes';
import { IceMultimediaCanvas } from './IceMultimediaCanvas';

export class IcePoint {
  x: number = 0;
  y: number = 0;
  z: number = 0;

  constructor(xD: number = 0, yD: number = 0, zD: number = 0) {
    this.x = xD;
    this.y = yD;
    this.z = zD;
  }
}

export class IceRect {
  left: number = 0;
  top: number = 0;
  right: number = 0;
  bottom: number = 0;
  constructor(l: number = 0, t: number = 0, r: number = 0, b: number = 0) {
    this.left = l;
    this.top = t;
    this.right = r;
    this.bottom = b;
  }

  inflateRect(l: number = 0, t: number = 0, r: number = 0, b: number = 0): void {
    this.left += l;
    this.top += t;
    this.right += r;
    this.bottom += b;
  }
  deflateRect(l: number = 0, t: number = 0, r: number = 0, b: number = 0): void {
    this.left -= l;
    this.top -= t;
    this.right -= r;
    this.bottom -= b;
  }
}

export class IceMultimediaStroke {

  attributes: IceMultimediaAttributes = null;
  pointArray: IcePoint[] = [];
  point: IcePoint;

  constructor(attr: IceMultimediaAttributes, pt: IcePoint) {
    this.attributes = attr;
    this.point = pt;
    this.pointArray.push(pt);
  }

  draw(canvas: IceMultimediaCanvas): void {
    if (canvas == null) return;
    canvas.context.beginPath();
    canvas.context.moveTo(canvas.prevPoint.x, canvas.prevPoint.y);
    canvas.context.lineTo(this.point.x, this.point.y);
    canvas.context.closePath();
    canvas.context.stroke();
    canvas.currentStroke.pointArray.push(this.point);
  }
};
